<template>
    <div id="res-store-list" class="dialog" style="display: none">
        <div class="dialog__container" style="padding: 0 10px; overflow-y: auto">
            <div class="header-box">
                <div class="title">
                    選擇你的店鋪
                </div>
                <div id="search-bar" class="res-store-list-search">
                    <input class="search" type="text" role="search" placeholder="輸入分店地址.." v-on:keyup.prevent="search"/>
                </div>
            </div>

            <ul id="store-list" class="mdc-list">
                <li id="store-list-item" class="mdc-list-item" v-for="store in stores">
                    <a :href="`/system/store/${store.id}/tables`">
                        <span class="mdc-list-item__text">[{{ store.formated_address }}]{{ store.name }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            stores: {
                type: Array,
                default: [],
            }
        },
        methods: {
            search(event) {
                let searchText = $(event.currentTarget).val();
                let filter = searchText.toUpperCase();
                let li = $('#store-list-item.mdc-list-item');

                for (let i = 0; i < li.length; i++)
                {
                    let a = $(li[i]).find('a');
                    let text = a.text().toUpperCase();
                    if (text.indexOf(filter) > -1) {
                        $(li[i]).show();
                    } else {
                        $(li[i]).hide();
                    }
                }
                console.log(searchText);
            }
        }
    }
</script>

<style lang="scss">
    #res-store-list {
        > .dialog__container {
            padding: 0 10px;
            overflow-y: auto;

            > .header-box {
                position: sticky;
                top: 0;
                background-color: #ffffff;
                padding: 10px 0;
                z-index: 2;

                > .title {

                }

                //noinspection CssUnknownTarget
                > .res-store-list-search input.search {
                    background-image: url("/css/svgs/solid/search-gray.svg");
                    background-position: 10px 12px;
                    background-size: 15px;
                    background-repeat: no-repeat;
                    width: calc(100% - 60px);
                    border: none;
                    border-bottom: 1px #e0e0e0 solid;
                    font-size: 0.8em;
                    font-weight: 300;
                    padding: 12px 20px 12px 40px;
                    transition: all 0.25s ease-in-out;

                    &:focus, &:active {
                        outline: none;
                        font-size: 1em;
                        border-color: var(--mdc-theme-primary);
                    }
                }
            }
        }
    }
</style>